export default __webpack_public_path__ + "static/media/party.5a75c22d.svg";